import { forwardRef } from "react";
import clsx from "clsx";
import { ActionIcon, ActionIconProps } from "@mantine/core";
import { CONTROL_BUTTON_SETTINGS } from "config/constants";
import classes from "./ControlActionIcon.module.css";

export const ControlActionIcon = forwardRef<
  HTMLButtonElement,
  ActionIconProps & React.ComponentPropsWithoutRef<"button">
>(({ children, className, ...rest }, ref) => {
  return (
    <ActionIcon
      ref={ref}
      variant="transparent"
      // A Popover or Tooltip target is given a className too
      className={clsx(classes.icon, className)}
      size={CONTROL_BUTTON_SETTINGS.size}
      {...rest}
    >
      {children}
    </ActionIcon>
  );
});
ControlActionIcon.displayName = "ControlActionIcon";
